// src/components/ServiceCard.js

import React from "react";
import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
  CardMedia,
} from "@mui/material";
import { Navigate } from "react-router-dom";

function ServiceCard({ service }) {
  const { id } = service;
  //const imageUrl = service.image || "/assets/fallback.jpg";

  const imageUrl = service.image === '' ? service.image : "/assets/fallback.jpg";
  return (
    <Card sx={{ minWidth: 275, height: "100%", display: "flex", flexDirection: "column" }}>
      <CardMedia
        component="img"
        height="140"
        image={imageUrl}
        alt={service.name}
        sx={{ objectFit: "cover" }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" gutterBottom>
          {service.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          {service.description}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          Preço: R$ {service.price}
        </Typography>
      </CardContent>
      <CardActions>
        
      <a href={`/service/${id}`} style={{textDecoration: 'none'}}>
        <Button size="small" color="primary">
          Detalhes
        </Button>
      </a>

      </CardActions>
    </Card>
  );
}

export default ServiceCard;
